module.exports = __webpack_public_path__ + "img/广东医科大学.919aef22.png";